export default __webpack_public_path__ + "static/media/settings_icon.991e237e.png";